<template>
  <el-card shadow="never">
    <template slot="header">
      <span class="el-card__left">我的消息</span>
    </template>
    <div class="bid-cotnainer">
      <div class="bid-tabs">
        <el-button
          v-for="(item, index) in tabs"
          :key="index"
          :class="{ 'active': item.value === active }"
          @click="tabChange(index)"
        >{{ item.name }}</el-button>
      </div>
      <div v-loading="isLoading" class="bid-list">
        <template v-if="list.length > 0">
          <bid-item
            v-for="(item, index) in list"
            :key="index"
            :content-length="126"
            :value="item"
            :is-preview="active === 1"
            :before-detail="beforeDetail"
            :extra-detail-query="{ inviteId: item.inviteUserId }"
          />

          <el-pagination
            background
            layout="prev, pager, next, jumper"
            :current-page="pagination.current"
            :page-size="pagination.size"
            :total="pagination.total"
            @current-change="pageChange"
          />
        </template>

        <empty-layout v-else />
      </div>
    </div>
  </el-card>
</template>

<script>
import BidItem from '@/components/BidItem'
import EmptyLayout from '@/components/EmptyLayout'
import { fetchUserMessage, fetchPreview, fetchUserMessageDetail } from '@/api'

export default {
  components: {
    BidItem,
    EmptyLayout
  },

  data() {
    return {
      tabs: [
        {
          value: 0,
          name: '招标消息'
        },
        {
          value: 1,
          name: '预告消息'
        }
      ],
      active: 0,

      list: [],

      pagination: {
        current: 1,
        size: 4,
        total: 0
      },

      isLoading: false
    }
  },

  mounted() {
    this.fetchMessage()
  },

  methods: {
    tabChange(index) {
      this.active = this.tabs[index].value
      this.list = []

      this.fetchMessage()
    },

    async fetchMessage(page = 1) {
      this.isLoading = true

      const params = {
        pageSize: this.pagination.size,
        pageNo: page
      }

      try {
        const result = await (this.active === 0 ? fetchUserMessage(params) : fetchPreview(params))

        let { records = [], total = 0 } = result.data

        if (this.active === 0) {
          records = records.map(val => {
            val.number = val.id
            val.name = val.title
            val.content = val.context

            return val
          })
        }

        this.list = records
        this.pagination.total = total
      } catch (error) {
        this.$message.error(error.message)
      }

      this.isLoading = false
    },

    beforeDetail(value) {
      fetchUserMessageDetail({
        id: value.id
      })

      return Promise.resolve()
    },

    pageChange(page) {
      document.documentElement.scrollTop = 0
      this.fetchMessage(page)
    }
  }
}
</script>

<style lang="scss" scoped>
.bid-tabs {
  .el-button {
    width: 105px;
    height: 40px;
    line-height: 38px;
    padding: 0;
    font-size: 16px;
    color: #417ef7;
    border-color: currentColor;
  }
  .active {
    color: #fff;
    background-color: #417ef7;
  }
}
.bid-list {
  margin: 30px 0 0;
  .el-pagination {
    display: table;
    margin: 20px auto 0;
  }
}
</style>
